import React, { useEffect, useRef, useState } from "react";
import { styles } from "../../../stylesheets/simulateurs.css";
import "../../../stylesheets/simulateursBis.css";
import TextSimulateurTitle from "../../../components/texts/text.simulateurTitle";
import TextfieldNumber from "../../../components/textfields/textfield.number";
import { setDMTGResultsObject } from "../../../actions/dmtg_results.action";
import { useDispatch } from "react-redux";
import Successions from "../../../components/dmtg/successions";
import { ToolTipPerso } from "../../../components/selects/tooltip_perso";
import ButtonYesno from "../../../components/buttons/button.yesno";
import TextfieldRemarques from "../../../components/textfields/textfiel.remarques";
import TextfieldAbattement from "../../../components/textfields/textfield.abattement";
import BadgeNouveau from "../../../components/texts/BadgeNouveau";
import SelectCommon from "../../../components/selects/select.common";
import {DesktopDatePicker, LocalizationProvider} from "@mui/x-date-pickers";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import TextField from "@mui/material/TextField";
import {useSnackbar} from "notistack";
import moment from "moment";

function Simulateur_Successions(props) {
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const conjointSurvivantStorageKey = "conjointSurvivantDMTG";

  //MONTANT A
  const [montant_brut, setBrut] = useState(props.montant_brut || 0);
  //MONTANT B
  const [donations_rapportables, setDonationsRapportables] = useState(props.donations_rapportables ?? null);
  //MONTANT C
  const [passif_succession, setPassifSuccession] = useState(0);
  //MONTANT D
  const [actif_net, setActifNet] = useState(0);
  //MONTANT E
  const [montant_succession, setSuccession] = useState(0);

  const [choix_meubles, setChoixMeubles] = useState(props.choix_meubles || 1);
  const [valeur_meubles, setValeurMeubles] = useState(props.valeur_meubles || 0);
  const [premier_deces_cs, setPremierDecesCS] = useState(0);
  const [donations_hors_succ, setDonationsHorsSucc] = useState(0);
  const [donations_partage, setDonationsPartage] = useState(0);
  const [residence_principale, setResidencePrincipale] = useState(0);
  const [age_cs, setAgeCS] = useState();
  const [option_cs, setOptionCS] = useState(1);
  const [masse_quart_theorique, setMasseQuartTheorique] = useState(0);
  const [masse_exercice, setMasseExercice] = useState(0);
  const [droits_cs, setDroitsCS] = useState(0);
  const [quart_pp, setQuartPP] = useState(null);
  const [nouvelle_masse_a_partager, setNouvelleMasseAPartager] = useState(null);
  const [calculCSDone, setCalculCSDone] = useState(false);
  const [isCalculatingCS, setIsCalculatingCS] = useState(false);
  const [cas_particulier, setParticulier] = useState(0);
  const [dateDonation, setDateDonation] = useState(new Date());
  const [lastDonationDate, setLastDonationDate] = useState();
  const [firstDonationDate, setFirstDonationDate] = useState();
  const [donataires, setDonataires] = useState(1);
  const [allDonatairesList, setAllDonatairesList] = useState([{}]);
  const resultsRef = useRef([{}]);
  let rappelFiscal;
  const optionsCS = [
    { id: 1, name: "Droits légaux : 1/4 en pleine propriété" },
    { id: 2, name: "Droits légaux : usufruit de l'universalité de la succession" },
    { id: 3, name: "Droits conventionnels : usufruit de l'universalité de la succession" },
    { id: 4, name: "Droits conventionnels : 1/4 en pleine propriété et 3/4 en usufruit" },
    { id: 5, name: "Droits conventionnels : quotité disponible en pleine propriété" },
  ];
  const formatEuro = (value) => `${parseInt(value || 0).toLocaleString("en-EN").replace(/,/g, " ")} €`;
  const getActifNetValue = () => parseInt(
    parseInt(montant_brut || 0)
    + parseInt(valeur_meubles || 0)
    - parseInt(passif_succession || 0)
    - (parseInt(premier_deces_cs) === 1 ? parseInt(residence_principale || 0) * 0.2 : 0)
  );
  const buildConjointSurvivantPdfResponse = (response, hasConjointSurvivant = parseInt(premier_deces_cs) === 1) => {
    const optionCSName = optionsCS.find((option) => parseInt(option.id) === parseInt(response?.option_cs))?.name || "-";
    const actifNetValue = parseInt(response?.actif_net ?? getActifNetValue());
    const autresBiens = Number(response?.actif_brut ?? montant_brut ?? 0)
      - Number(response?.residence_principale ?? residence_principale ?? 0);
    const residencePrincipaleValue = Number(response?.residence_principale ?? residence_principale ?? 0);
    const passifValue = Number(response?.passif_succession ?? passif_succession ?? 0);
    const synthesisItems = [
      { key: "actif_brut", name: "Actif brut de succession", value: formatEuro(response?.actif_brut ?? montant_brut) },
      ...(residencePrincipaleValue > 0 ? [
        { key: "residence_principale", name: "Résidence principale dépendant de la succession", value: formatEuro(residencePrincipaleValue) },
        { key: "autres_biens", name: "Autres biens immobiliers / Liquidités / placements", value: formatEuro(autresBiens) },
      ] : []),
      { key: "valeur_meubles", name: "Valeur des meubles meublants", value: formatEuro(response?.valeur_meubles ?? valeur_meubles) },
      ...(passifValue !== 0 ? [{ key: "passif_succession", name: "Passif de succession", value: formatEuro(passifValue) }] : []),
      { key: "actif_net", name: "Actif net de succession", value: formatEuro(actifNetValue) },
    ];

    if (parseInt(response?.donations_rapportables ?? donations_rapportables ?? 0) > 0) {
      synthesisItems.push({
        key: "donations_rapportables",
        name: "Montant total des donations rapportables, qu'elles aient plus ou moins de 15 ans",
        value: formatEuro(response?.donations_rapportables ?? donations_rapportables),
      });
    }

    if (parseInt(response?.donations_hors_succ ?? donations_hors_succ ?? 0) > 0) {
      synthesisItems.push({
        key: "donations_hors_succ",
        name: "Montant total des donations hors part successorale, qu'elles aient plus ou moins de 15 ans",
        value: formatEuro(response?.donations_hors_succ ?? donations_hors_succ),
      });
    }

    if (hasConjointSurvivant) {
      if ([2, 3, 4].includes(parseInt(response?.option_cs || 0)) && parseInt(response?.age_cs || 0) > 0) {
        synthesisItems.push({
          key: "age_cs",
          name: "Âge du conjoint survivant",
          value: `${parseInt(response.age_cs)} ans`,
        });
      }

      if ([1, 3].includes(parseInt(response?.option_cs || 0)) && parseInt(response?.masse_quart_theorique || 0) > 0) {
        synthesisItems.push({
          key: "masse_quart_theorique",
          name: "Masse servant au calcul du quart théorique",
          value: formatEuro(response.masse_quart_theorique),
        });
      }

      if ([1, 3].includes(parseInt(response?.option_cs || 0)) && parseInt(response?.masse_exercice || 0) > 0) {
        synthesisItems.push({
          key: "masse_exercice",
          name: "Masse d'exercice des droits du conjoint survivant",
          value: formatEuro(response.masse_exercice),
        });
      }

      synthesisItems.push({
        key: "droits_cs",
        name: "Option du conjoint survivant",
        value: optionCSName,
        amount: formatEuro(response?.droits_cs),
      });

      if (Number(response?.option_cs) === 4) {
        const pleinePropriete = Number(response?.quart_pp ?? actifNetValue / 4);
        synthesisItems.push({
          key: "repartition_droits_cs",
          name: "Dont",
          value: `${formatEuro(pleinePropriete)} en pleine propriété et ${formatEuro(Number(response?.droits_cs || 0) - pleinePropriete)} en usufruit`,
        });
      }

      synthesisItems.push({
        key: "nouvelle_masse_a_partager",
        name: "Masse à partager entre les héritiers",
        value: formatEuro(response?.nouvelle_masse_a_partager),
      });
    } else {
      synthesisItems.push({
        key: "masse_a_partager",
        name: "Masse à partager",
        value: formatEuro(response?.masse_a_partager),
      });
    }

    const resultItems = hasConjointSurvivant ? [
      { key: "droits_cs", name: "Droits du conjoint survivant", value: formatEuro(response?.droits_cs) },
      {
        key: "nouvelle_masse_a_partager",
        name: "Masse à partager entre les héritiers",
        value: formatEuro(response?.nouvelle_masse_a_partager),
      },
    ] : [];
    const items = hasConjointSurvivant ? [
      { key: "option_cs", name: "Option du conjoint survivant", value: optionCSName },
    ] : [];

    if (hasConjointSurvivant && parseInt(response?.age_cs || 0) > 0) {
      items.push({ key: "age_cs", name: "Age du conjoint survivant", value: `${parseInt(response.age_cs)} ans` });
    }
    if (hasConjointSurvivant && parseInt(response?.masse_quart_theorique || 0) > 0) {
      items.push({
        key: "masse_quart_theorique",
        name: "Masse servant au calcul du quart théorique",
        value: formatEuro(response.masse_quart_theorique),
      });
    }
    if (hasConjointSurvivant && parseInt(response?.masse_exercice || 0) > 0) {
      items.push({
        key: "masse_exercice",
        name: "Masse d'exercice des droits du conjoint survivant",
        value: formatEuro(response.masse_exercice),
      });
    }

    items.push(...resultItems);

    return {
      items,
      resultItems,
      synthesisItems,
    };
  };

  const donations_anterieures = parseInt(donations_rapportables || 0) > 0 || parseInt(donations_hors_succ || 0) > 0;
  const donations_anterieures_avec_partage = donations_anterieures || parseInt(donations_partage || 0) > 0;
  const requiresQuartLegal = parseInt(premier_deces_cs) === 1 && donations_anterieures && [1, 3].includes(parseInt(option_cs || 0));
  const requiresDonationsPartage = parseInt(premier_deces_cs) === 1 && parseInt(option_cs || 0) === 5;
  const requiresAgeCS = parseInt(premier_deces_cs) === 1 && [2, 3, 4].includes(parseInt(option_cs || 0));
  const droitsCSTooltip = parseInt(option_cs || 0) === 3 && donations_anterieures
    ? "Le conjoint peut compléter ses droits légaux sur le quart légal en pleine propriété lorsque la valeur de son droit d’usufruit est inférieure à ce quart, sauf à ce que le défunt l’ait privé de ses droits légaux par testament."
    : parseInt(option_cs || 0) === 5 && donations_anterieures_avec_partage
      ? "Attention : les cas entraînant une indemnité de réduction ou de rapport ne sont pas traités ici."
      : null;
  
  useEffect(() => {
    if (!props.callSinceSimu) return;
    setBrut(parseInt(props.montant_brut || 0));
    setChoixMeubles(parseInt(props.choix_meubles || 1));
    setValeurMeubles(parseInt(props.valeur_meubles || 0));
    setDonationsRapportables(
      props.donations_rapportables === undefined || props.donations_rapportables === null
      ? null
      : parseInt(props.donations_rapportables)
    );
  }, [
    props.callSinceSimu,
    props.montant_brut,
    props.choix_meubles,
    props.valeur_meubles,
    props.donations_rapportables,
  ]);

  useEffect(() => {
    const actifNetValue = getActifNetValue();
    const successionValue = calculCSDone && nouvelle_masse_a_partager !== null
      ? nouvelle_masse_a_partager
      : actifNetValue + parseInt(donations_rapportables || 0);
    setActifNet(actifNetValue);
    setSuccession(successionValue);

    handleChange(setSuccession, successionValue);
  }, [montant_brut, valeur_meubles, passif_succession, donations_rapportables, residence_principale, premier_deces_cs, calculCSDone, nouvelle_masse_a_partager,
  ]);

  useEffect(() => {
    if (parseInt(choix_meubles) === 1) {
      const newValeurMeubles = ((parseInt(montant_brut || 0) - (parseInt(residence_principale || 0) * 0.2)) * 0.05);
      setValeurMeubles(newValeurMeubles);
      handleChange(setValeurMeubles, newValeurMeubles);
    }
  }, [montant_brut, choix_meubles, residence_principale]);

  useEffect(() => {
    if (!calculCSDone) return;
    localStorage.removeItem(conjointSurvivantStorageKey);
    setCalculCSDone(false);
    setDroitsCS(0);
    setNouvelleMasseAPartager(null);
  }, [premier_deces_cs,
    montant_brut,
    passif_succession,
    donations_rapportables,
    donations_hors_succ,
    donations_partage,
    residence_principale,
    donataires,
    age_cs,
    option_cs,
    masse_quart_theorique,
    masse_exercice,
    choix_meubles,
    valeur_meubles,
  ]);

  useEffect(() => {
    if (donations_anterieures) return;
    setMasseQuartTheorique(0);
    setMasseExercice(0);
  }, [donations_anterieures]);

  useEffect(() => {
    if (!props.registerBeforeCalculate) return;
    props.registerBeforeCalculate(calculateConjointSurvivant);

    return () => {
      props.registerBeforeCalculate(null);
    };
  }, [
    props.registerBeforeCalculate,
    premier_deces_cs,
    montant_brut,
    valeur_meubles,
    residence_principale,
    passif_succession,
    donations_rapportables,
    donations_hors_succ,
    donations_partage,
    donataires,
    age_cs,
    option_cs,
    masse_quart_theorique,
    masse_exercice,
    choix_meubles,
    calculCSDone,
    droits_cs,
    quart_pp,
    nouvelle_masse_a_partager,
  ]);

  const handleChange = async (setter, value) => {
    if (setter === setDonataires && value >= 9) {
        enqueueSnackbar('Le nombre d\'héritiers ne peut dépasser 9', {
          variant: 'warning'
        });
    }

    if (setter === setDateDonation && lastDonationDate) {
      console.log("Last Donation: ", lastDonationDate)
      console.log("First Donation: ", firstDonationDate)
      if (value < lastDonationDate) {
        enqueueSnackbar("La date doit être postérieure à celle de la donation antèrieure", {
          variant: "error",
        });
        return;
      }
      rappelFiscal = new Date(value);
      rappelFiscal.setFullYear(rappelFiscal.getFullYear() - 15);
      if (firstDonationDate &&
          firstDonationDate < parseInt(moment(rappelFiscal.toString()).utc(true).format("x"))
         ) {
          enqueueSnackbar(
              "Vous aurez une ou plusieurs donations antérieures en dehors du rappel fiscal, merci de vérifier les données renseignées",
              {
                variant: "error",
              }
          );
          return;
        }
    }
    if (setter === setBrut) {
      setBrut(parseInt(value));
    } else if (setter === setPremierDecesCS) {
      setPremierDecesCS(parseInt(value));
      if (props.callSinceSimu && props.onConjointSurvivantChange) {
        props.onConjointSurvivantChange(parseInt(value) === 1);
      }
      if (parseInt(value) !== 1) {
        localStorage.removeItem(conjointSurvivantStorageKey);
        setDonationsPartage(0);
        setResidencePrincipale(0);
        setMasseQuartTheorique(0);
        setMasseExercice(0);
        setDroitsCS(0);
        setNouvelleMasseAPartager(null);
        setCalculCSDone(false);
        setAgeCS(null);
      }
    } else if (setter === setDonationsRapportables) {
      const donationsRapportablesValue = 
      value === "" || value === null || value === undefined ? null : parseInt(value);
      setDonationsRapportables(donationsRapportablesValue);
    } else if (setter === setPassifSuccession) {
      setPassifSuccession(parseInt(value));
    } else if (setter === setResidencePrincipale) {
      if (parseInt(value) >= montant_brut) {
        enqueueSnackbar(
              "La valeur de la résidence principale doit être comprise dans l'actif brut de succession. Par conséquent, elle ne peut pas être supérieure à celui-ci.",
              {
                variant: "warning",
              }
          );
          return;
      } else {
        setResidencePrincipale(parseInt(value));
      }
    } else if (setter === setDonationsHorsSucc) {
      setDonationsHorsSucc(parseInt(value));
    } else if (setter === setDonationsPartage) {
      setDonationsPartage(parseInt(value));
    } else if (setter === setAgeCS) {
      setAgeCS(value === "" ? null : parseInt(value));
    } else if (setter === setOptionCS) {
      const newOption = parseInt(value);
      setOptionCS(newOption);
      if (![2, 3, 4].includes(newOption)) {
        setAgeCS(null);
      }
      if (newOption !== 5) {
        setDonationsPartage(0);
      }
      if (![1, 3].includes(newOption)) {
        setMasseQuartTheorique(0);
        setMasseExercice(0);
      }
    } else if (setter === setMasseQuartTheorique) {
      setMasseQuartTheorique(parseInt(value));
    } else if (setter === setMasseExercice) {
      setMasseExercice(parseInt(value));
    } else if (setter === setChoixMeubles) {
      const choixMeublesValue = parseInt(value);
      if (choixMeublesValue === 2) {
        setValeurMeubles(0);
      }
      setChoixMeubles(choixMeublesValue);
    } else if (setter === setValeurMeubles){
      setValeurMeubles(parseInt(value));
    } else setter(value);
  };

  const runConjointSurvivantCalculation = async () => {
    if (parseInt(premier_deces_cs) !== 1) {
      return null;
    }

    setIsCalculatingCS(true);

    try {
      const response = await props.onCalculateConjointSurvivant({
        simulateurid: 119,
        inputs: {
          actif_brut: parseInt(montant_brut || 0),
          choix_meubles: parseInt(choix_meubles),
          valeur_meubles: parseInt(valeur_meubles || 0),
          residence_principale: parseInt(residence_principale || 0),
          passif_succession: parseInt(passif_succession || 0),
          donations_rapportables: parseInt(donations_rapportables || 0),
          donations_hors_succ: parseInt(donations_hors_succ || 0),
          donations_partage: parseInt(donations_partage || 0),
          nombre_heritiers: parseInt(donataires || 0),
          age_cs: parseInt(age_cs || 0),
          option_cs: parseInt(option_cs || 0),
          masse_quart_theorique: parseInt(masse_quart_theorique || 0),
          masse_exercice: parseInt(masse_exercice || 0),
        },
      });
      const droitsCSValue = parseInt(response?.droits_cs || 0);
      const nouvelleMasseValue = parseInt(response?.nouvelle_masse_a_partager || 0);
      const conjointSurvivantResult = {
        ...response,
        droits_cs: droitsCSValue,
        nouvelle_masse_a_partager: nouvelleMasseValue,
        actif_brut: parseInt(montant_brut || 0),
        valeur_meubles: parseInt(valeur_meubles || 0),
        residence_principale: parseInt(residence_principale || 0),
        passif_succession: parseInt(passif_succession || 0),
        actif_net: getActifNetValue(),
        donations_rapportables: parseInt(donations_rapportables || 0),
        donations_hors_succ: parseInt(donations_hors_succ || 0),
        option_cs: parseInt(option_cs || 0),
        age_cs: parseInt(age_cs || 0),
        masse_quart_theorique: parseInt(masse_quart_theorique || 0),
        masse_exercice: parseInt(masse_exercice || 0),
      };

      setDroitsCS(droitsCSValue);
      setQuartPP(response?.quart_pp ?? getActifNetValue() / 4);
      setNouvelleMasseAPartager(nouvelleMasseValue);
      setCalculCSDone(true);
      const pdfResponse = buildConjointSurvivantPdfResponse(conjointSurvivantResult);
      localStorage.setItem(conjointSurvivantStorageKey, JSON.stringify(pdfResponse));
      return conjointSurvivantResult;
    } catch (error) {
      if (error.response?.status === 401 && error.response.data != null) {
        if (error.response.data.error == "Other_user_connected") {
          localStorage.removeItem("user");
          localStorage.setItem("other_user_connected", "other_user_connected");
          window.location.href = "/login";
          return;
        } else {
          localStorage.removeItem("user");
          window.location.href = "/login";
          enqueueSnackbar('Session expirée', {variant: 'error'});
          return;
        }
      }

      enqueueSnackbar(error?.response?.data?.error || error?.message || "Erreur lors du calcul du conjoint survivant.", {
        variant: "error",
      });
      return false;
    } finally {
      setIsCalculatingCS(false);
    }
  };

  const calculateConjointSurvivant = async () => {
    const totalRapportable = Number(donations_rapportables) || 0;
    const heritiers = (resultsRef.current[0]?.donataires || []).slice(0, Number(donataires));
    const totalHeritiers = heritiers.reduce(
      (total, heritier) => total + (Number(heritier?.inputs?.montant_rapportable) || 0), 0
    );
    if (totalHeritiers !== totalRapportable) {
      enqueueSnackbar(totalRapportable > 0 && totalHeritiers === 0
        ? "Vous avez indiqué un montant de donation rapportable plus haut, merci de le reporter les montants corrects dans le champ des héritiers"
        : "La somme des donations rapportables des héritiers doit être égale au montant total des donations rapportables de la succession.",
        { variant: "error" }
      );
      return false;
    }

    if (parseInt(premier_deces_cs) !== 1) {
      const successionSynthesisResult = {
        actif_brut: parseInt(montant_brut || 0),
        valeur_meubles: parseInt(valeur_meubles || 0),
        residence_principale: parseInt(residence_principale || 0),
        passif_succession: parseInt(passif_succession || 0),
        donations_rapportables: parseInt(donations_rapportables || 0),
        donations_hors_succ: parseInt(donations_hors_succ || 0),
        actif_net: getActifNetValue(),
        masse_a_partager: getActifNetValue() + parseInt(donations_rapportables || 0),
      };
      const pdfResponse = buildConjointSurvivantPdfResponse(successionSynthesisResult, false);
      localStorage.setItem(conjointSurvivantStorageKey, JSON.stringify(pdfResponse));
      return null;
    }

    if (!calculCSDone || nouvelle_masse_a_partager === null) {
      enqueueSnackbar("Veuillez d'abord calculer les droits du conjoint survivant.", {
        variant: "warning",
      });
      return false;
    }

    const conjointSurvivantResult = {
      droits_cs: parseInt(droits_cs || 0),
      quart_pp,
      nouvelle_masse_a_partager: parseInt(nouvelle_masse_a_partager || 0),
      actif_brut: parseInt(montant_brut || 0),
      valeur_meubles: parseInt(valeur_meubles || 0),
      residence_principale: parseInt(residence_principale || 0),
      passif_succession: parseInt(passif_succession || 0),
      donations_rapportables: parseInt(donations_rapportables || 0),
      donations_hors_succ: parseInt(donations_hors_succ || 0),
      actif_net: getActifNetValue(),
      option_cs: parseInt(option_cs || 0),
      age_cs: parseInt(age_cs || 0),
      masse_quart_theorique: parseInt(masse_quart_theorique || 0),
      masse_exercice: parseInt(masse_exercice || 0),
    };
    const pdfResponse = buildConjointSurvivantPdfResponse(conjointSurvivantResult);
    localStorage.setItem(conjointSurvivantStorageKey, JSON.stringify(pdfResponse));
    return conjointSurvivantResult;
  };

  const handleChangeRemarque = async (value) => {
    localStorage.setItem("remarque", value);
  };

  // Fonction call depuis le component enfant qui set la key du state "results" modifiée.
  function FunctionSetResults(key, value) {
    const updated = [...resultsRef.current];
    updated[key] = value;
    resultsRef.current = updated;
    setInRedux(updated);
  }

  function FunctionSetAllDonatairesList(key, value) {
    allDonatairesList[key] = value;
    //console.log("iciii")
    //console.log(value)
  }

  function setInRedux(results) {
    let object = { results: results };
    Object.assign(object["results"], results);
    //console.log(object)
    dispatch(setDMTGResultsObject(object));
  }

  const choixMeubles = [
    {
      id: 1,
      name: "Forfait mobilier (5% de l'actif brut)",
    },
    {
      id: 2,
      name: "Valeur déterminée selon inventaire",
    },
  ];

  const buttonCalculatePrincipalStyle = {
    display: "inline-block",
    margin: 0,
    justifySelf: "start",
    width: "320px",
    maxWidth: "100%",
    minHeight: 35,
    borderRadius: 5,
    border: "none",
    backgroundColor: "#49708C",
    color: "#FFFFFF",
    fontWeight: "bold",
    cursor: "pointer",
    boxShadow: "2px 2px 1px rgba(0,0,0, 0.2)",
    padding: "8px 18px",
    textAlign: "center",
  };

  return (
    <div style={styles.container}>
      <div className={props.callSinceSimu ? "cardDMTG" : "cardSimulateur"}>
        {props.callSinceSimu ? (
          <></>
        ) : (
          <>
            <TextSimulateurTitle title={"DMTG - Succession 1 à 9 personnes (1er et 2e décès)"} currentSimuId={props.simulateur.id} />

            <TextfieldRemarques handleChange={handleChangeRemarque} />
          </>
        )}

        <div className="cardRow">
          <div style={styles.cardElemVerticalyCenter}>
            Le défunt était-il dans un cas particulier ?
            <ToolTipPerso
              title={
                " - Victime de guerre ou d'acte de terrorisme ;\n" +
                " - Militaire décédé en opération extérieure ou au cours d'une opération de sécurité intérieure ou décédé suite à des blessures reçues durant de telles opérations ;\n" +
                " - Sapeur-pompier, policier, gendarme ou agent des douanes, cité à l'ordre de la Nation, décédé en service ou suite à des blessures reçues en service."
              }
            />
          </div>
          <ButtonYesno handleChange={handleChange} setter={setParticulier} defaultValue={0} />
        </div>
        {parseInt(cas_particulier) === 1 ? (
          <div>
            <div style={styles.messageInABottle}>Le ou les bénéficaires sont exonérés de droits</div>
          </div>
        ) : (
          <>
            <div className="cardRow">
              <div style={styles.cardElemVerticalyCenter}>Indiquer la date du décès</div>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DesktopDatePicker
                  inputFormat="DD/MM/YYYY"
                  value={dateDonation}
                  onChange={(val) => {
                    handleChange(setDateDonation, val);
                  }}
                  renderInput={(params) => <TextField {...params} />}
                />
              </LocalizationProvider>
            </div>
            
            <div className="cardRow">
              <div style={styles.cardElemVerticalyCenter}>
                S’agit-il du <strong className="successionQuestionEmphasis">premier décès</strong> avec conjoint survivant ?
                <BadgeNouveau cliquable={false} />
              </div>
              <div>
                <ButtonYesno handleChange={handleChange} setter={setPremierDecesCS} defaultValue={premier_deces_cs} />
              </div>
            </div>

            {!props.callSinceSimu ? (
              <>
                {/*MONTANT A*/}
                <div className="cardRow">
                  <div style={styles.cardElemVerticalyCenter}>
                    Actif brut de succession :
                    <ToolTipPerso
                      title={
                        parseInt(premier_deces_cs) === 1
                          ? "Totalité de l’actif, en ce compris, le cas échéant, la moitié de communauté et la résidence principale occupée par le défunt et son conjoint survivant, partenaire de PACS et/ou enfants mineurs ou majeurs protégés."
                          : "Pour le calcul de l’émolument, l’assiette a pour base l’actif brut total, en ce compris s’il y a communauté, participation ou société d’acquêts, les biens qui en dépendent (C. com., art. A. 444-63, Tableau 5, n° 8)."
                      }
                    />
                  </div>
                  <TextfieldNumber
                    handleChange={handleChange}
                    type={"number"}
                    placeholder={"Indiquer le montant"}
                    setter={setBrut}
                  />
                </div>
              </>
            ) : (
              <></>
            )}

            {parseInt(premier_deces_cs) === 1 ? (
              <div className="cardRow">
                <div style={styles.cardElemVerticalyCenter}>
                  {!props.callSinceSimu ? "Dont partie de la r" : "R"}ésidence principale dépendant de la succession :
                  <ToolTipPerso
                    title={
                      "Valeur vénale (la moitié si c'est un bien commun) de la résidence principale occupée par le défunt et son conjoint survivant, partenaire de PACS et/ou enfants mineurs ou majeurs protégés, sur laquelle sera appliqué un abattement de 20 % pour le calcul des droits de succession (CGI, art. 764 bis)."
                    }
                  />
                </div>
                <TextfieldNumber
                  handleChange={handleChange}
                  type={"number"}
                  placeholder={"Indiquer le montant"}
                  setter={setResidencePrincipale}
                  max={montant_brut}
                />
              </div>
            ) : (
              <></>
            )}

            {!props.callSinceSimu || parseInt(premier_deces_cs) === 1 ? (
              <>
                {/*MEUBLES MEUBLANTS*/}
                <div className="cardRow">
                  <div style={styles.cardElemVerticalyCenter}>
                    Meubles meublants :
                  </div>
                  <SelectCommon
                      items={choixMeubles}
                      defaultValue={choix_meubles}
                      nameField={"name"}
                      optionValue={"id"}
                      handleChange={handleChange}
                      setter={setChoixMeubles}
                  />
                </div>
                <div className="cardRow">
                  <div style={styles.cardElemVerticalyCenter}>
                    Valeur des meubles meublants :
                  </div>
                  {parseInt(choix_meubles) === 2 ? (
                    <TextfieldNumber
                      handleChange={handleChange}
                      type={"number"}
                      placeholder={"Indiquer le montant"}
                      setter={setValeurMeubles}
                    />
                  ) : (
                      <>
                        <TextfieldAbattement
                            type={"number"}
                            placeholder={valeur_meubles.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") + " €"}
                        />
                      </>
                  )}
                </div>
              </>
            ) : null}

            {/*MONTANT C*/}
            <div className="cardRow">
              <div style={styles.cardElemVerticalyCenter}>
                Passif de succession :
                <ToolTipPerso
                  title={
                    "Indiquer le montant du passif au sens fiscal"
                  }
                />
              </div>
              <TextfieldNumber
                handleChange={handleChange}
                type={"number"}
                placeholder={"Indiquer le montant"}
                setter={setPassifSuccession}
              />
            </div>

            {!props.callSinceSimu ? (
              <>
                {/*MONTANT B*/}
                <div className="cardRow">
                  <div style={styles.cardElemVerticalyCenter}>
                    Montant total des donations rapportables, qu'elles aient plus ou moins de 15 ans :
                    <ToolTipPerso
                      title={
                        "S’il y a des donations antérieures, seules les donations rapportables au sens civil sont à inclure dans l’assiette de l’émolument proportionnel pour leur valeur rapportable au jour du décès, quelle que soit leur ancienneté."
                      }
                    />
                  </div>
                  <TextfieldNumber
                    handleChange={handleChange}
                    type={"number"}
                    placeholder={"Indiquer le montant"}
                    setter={setDonationsRapportables}
                  />
                </div>
              </>
            ) : null}

            <div className="cardRow">
              <div style={styles.cardElemVerticalyCenter}>
                Montant total des donations hors part successorale, qu'elles aient plus ou moins de 15 ans :
              </div>
              <TextfieldNumber
                handleChange={handleChange}
                type={"number"}
                placeholder={"Indiquer le montant"}
                setter={setDonationsHorsSucc}
              />
            </div>

            <div className="cardRow">
              <div style={styles.cardElemVerticalyCenter}>Actif net de succession</div>
              <TextfieldAbattement
                type={"number"}
                placeholder={actif_net.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") + " €"}
              />
            </div>

            <div className="cardRow">
              <div style={styles.cardElemVerticalyCenter}>{parseInt(premier_deces_cs) === 1 ? "Hormis le conjoint survivant, combien d'héritiers sont concernés ?" : "Combien d'héritiers sont concernés ?"}
                <ToolTipPerso
                    title={
                      "En cas de représentation, indiquer le nombre de souches, le nombre de représentants sera à faire apparaître ensuite, dans la partie dédiée à la souche concernée."
                    }
                />
              </div>
              <TextfieldNumber
                handleChange={handleChange}
                type={"number"}
                defaultValue={donataires}
                placeholder={"Nombre d'héritiers"}
                setter={setDonataires}
                max={9}
              />
            </div>

            {parseInt(premier_deces_cs) === 1 ? (
              <>
                <div className="cardRow">
                  <div style={styles.cardElemVerticalyCenter}>
                    Quelle est l’option du conjoint survivant ?
                    <ToolTipPerso
                      title={
                        "L'option de l'usufruit légal est possible uniquement si le défunt ne laisse pas d’enfants d’une autre union (C. civ., art. 757). "
                      }
                    />
                  </div>
                  <SelectCommon
                    items={optionsCS}
                    defaultValue={option_cs}
                    nameField={"name"}
                    optionValue={"id"}
                    handleChange={handleChange}
                    setter={setOptionCS}
                  />
                </div>

                {requiresDonationsPartage ? (
                  <div className="cardRow">
                    <div style={styles.cardElemVerticalyCenter}>
                      Quel est le montant total des donations partages ?
                    </div>
                    <TextfieldNumber
                      handleChange={handleChange}
                      type={"number"}
                      placeholder={"Indiquer le montant"}
                      setter={setDonationsPartage}
                    />
                  </div>
                ) : (
                  <></>
                )}

                {requiresAgeCS ? (
                  <div className="cardRow">
                    <div style={styles.cardElemVerticalyCenter}>
                      Quel âge avait le conjoint survivant au jour du décès ?
                    </div>
                    <TextfieldNumber
                      handleChange={handleChange}
                      type={"number"}
                      placeholder={"Indiquer l'âge"}
                      setter={setAgeCS}
                      max={120}
                    />
                  </div>
                ) : (
                  <></>
                )}

                {requiresQuartLegal ? (
                  <>
                    <div className="cardRow">
                      <div style={styles.cardElemVerticalyCenter}>
                        Quel est le montant de la masse servant au calcul du quart théorique ?
                        <ToolTipPerso
                            title={
                              "Valeur civile des biens existants + valeur des donations rapportables (débat concernant l’intégration des donations-partages en avancement de part successorale)."
                            }
                        />
                      </div>
                      <TextfieldNumber
                        handleChange={handleChange}
                        type={"number"}
                        placeholder={"Indiquer le montant"}
                        setter={setMasseQuartTheorique}
                      />
                    </div>

                    <div className="cardRow">
                      <div style={styles.cardElemVerticalyCenter}>
                        Quel est le montant de la masse d'exercice des droits du conjoint survivant ?
                        <ToolTipPerso
                            title={
                              "Masse de calcul du ¼ théorique déduction faite de la réserve globale (valeur civile) et des libéralités en avancement de part successorale excédant la quotité disponible."
                            }
                        />
                      </div>
                      <TextfieldNumber
                        handleChange={handleChange}
                        type={"number"}
                        placeholder={"Indiquer le montant"}
                        setter={setMasseExercice}
                      />
                    </div>
                  </>
                ) : (
                  <></>
                )}

                <div className="cardRow">
                  <button
                    style={buttonCalculatePrincipalStyle}
                    type="button"
                    onClick={() => {
                      runConjointSurvivantCalculation();
                    }}
                    disabled={isCalculatingCS}
                  >
                    {isCalculatingCS ? "Calcul en cours..." : "Calculer les droits du conjoint survivant"}
                  </button>
                </div>

                <div className="cardRow">
                  <div style={styles.cardElemVerticalyCenter}>
                    Droits du conjoint survivant
                    {droitsCSTooltip ? <ToolTipPerso title={droitsCSTooltip} /> : null}
                    <span style={{ fontSize: 14, color: "#5E91B6", marginLeft: 5 }}> (Exonération de droits de succession)</span>
                  </div>
                  <TextfieldAbattement
                    type={"number"}
                    placeholder={`${(droits_cs || 0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")} €`}
                  />
                </div>

                <div className="cardRow">
                  <div style={styles.cardElemVerticalyCenter}>Masse à partager entre les héritiers</div>
                  <TextfieldAbattement
                    type={"number"}
                    placeholder={`${(montant_succession || 0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")} €`}
                  />
                </div>
              </>
            ) : (
              <></>
            )}

            <div className="cardDonateurs">
              <Successions
                handleChange={handleChange}
                resultKey={0}
                functionSetResults={FunctionSetResults}
                FunctionSetAllDonatairesList={FunctionSetAllDonatairesList}
                dateDonation={dateDonation}
                setLastDonationDate={setLastDonationDate}
                setFirstDonationDate={setFirstDonationDate}
                donataires={donataires}
                simulateurid={props.simulateur.id}
                // Check if it's called by another simulateur
                total_rapportable={donations_rapportables}
                total_succession={montant_succession}
              />
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default Simulateur_Successions;
